module.exports = __webpack_public_path__ + "img/locationMap4.2b0df95e.png";